<template>
  <div id="app">
    <keep-alive include="graduation">
      <router-view/>
    </keep-alive>
    <alert/>
  </div>
</template>
<script>
import alert from '@/components/alert/alert';
import api from '@/api';
import { getUserInfo, get_tUser, getCookieValue} from '@/assets/js/util';

export default {
  name: 'App',
  components: {
    alert
  },
  created() {
    // this.$store.dispatch('me/getAccountUsersMobileAccountIndex');
    this.$store.dispatch('me/getUserInfo');
  },
  mounted() {
    console.log(
      "\\ \\        / /            | |          / ____\\ \\    / /\n"+
      " \\ \\  /\\  / /__  _ __   __| | ___ _ __| |     \\ \\  / / \n"+
      "  \\ \\/  \\/ / _ \\| '_ \\ / _` |/ _ \\ '__| |      \\ \\/ /  \n"+
      "   \\  /\\  / (_) | | | | (_| |  __/ |  | |____   \\  /   \n"+
      "    \\/  \\/ \\___/|_| |_|\\__,_|\\___|_|   \\_____|   \\/    \n"
    )
    console.log('%c 欢迎加入超级简历 招聘地址：https://www.wondercv.com/company/0ad28612751011ea.html','color:#f00;')
    try {
      let metaDom = document.querySelector('meta[name=revised]');
      let version = metaDom.getAttribute('content');
      console.log(`vue code version: ${version}`);
    } catch (error) {}

    setTimeout(() => {
      this.loadUdesk();
    }, 500);
  },
  methods: {
    // Udesk 启动客服
    async loadUdesk(){
      api.account.udeskOnlineUrl({}).then(res=>{
        if(res.code === 1000){
          let udeskArray = Object.assign(res.data.arr1, res.data.arr2);
          //定时器启动
          setTimeout(() => {
            (function(a,h,c,b,f,g){
              a["UdeskApiObject"]=f;
              a[f] = a[f] || function(){(
                a[f].d=a[f].d||[]
                ).push(arguments)
              };
              g = h.createElement(c);
              g.async=1;
              g.charset="utf-8";
              g.src=b;
              c=h.getElementsByTagName(c)[0];
              c.parentNode.insertBefore(g,c)
            })(window,document,"script","//assets-cli.udesk.cn/im_client/js/udeskApi.js","ud");
            //传递信息
            ud(udeskArray);
            // 获取覆盖元素 没有覆盖元素则创建覆盖元素覆盖 '一'   样式在 @assets/css/common.scss
            setTimeout(() => {
              let ele = document.getElementsByClassName('udesk_shade')
              if (!ele.length) {
                let udesk_panel = document.getElementById('udesk_panel');
                let shade = document.createElement('div')
                shade.setAttribute('class','udesk_shade')
                udesk_panel.append(shade)
              }
            },1000)
          }, 1000);

        }
      });


    },
  },
}
</script>

<style lang="scss">

@media print { 
  body {
    display: none;
  } 
}

// 共有css暂时写这里
// 超出省略号显示
.text-overflow {
  word-break: keep-all;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.position-r {
  position: relative;
}

.flex { display: flex; }
.justify-s-b { justify-content: space-between; }
.align-items-center { align-items: center; }
.margin-0 { margin: 0; }
.padding-0 { padding: 0; }
.width { width: 100%; }

.margin-top-24 { margin-top: 24px; }
.margin-top-30 { margin-top: 30px; }
.margin-top-32 { margin-top: 32px; }
.margin-top-36 { margin-top: 36px; }
.margin-top-38 { margin-top: 38px; }

.padding-lr-24 { padding: 0 24px; }
.pointer { cursor: pointer; }

.bg-color-fff { background: #fff; }

// 字体12-38 上左下右margin12-38
@for $i from 12 to 38 {
  .font-size-#{$i} { font-size: #{$i}px; }
    .mar-t-#{$i} { margin-top: #{$i}px; }
    .mar-l-#{$i} { margin-left: #{$i}px; }
    .mar-b-#{$i} { margin-bottom: #{$i}px; }
    .mar-r-#{$i} { margin-right: #{$i}px; }

    .pad-t-#{$i} { padding-top: #{$i}px; }
    .pad-l-#{$i} { padding-left: #{$i}px; }
    .pad-b-#{$i} { padding-bottom: #{$i}px; }
    .pad-r-#{$i} { padding-right: #{$i}px; }
}
// 字重100-900, zindex 1-9
@for $i from 1 to 9 {
  .font-weight-#{$i}00 {
    font-weight: #{$i}00;
  }
  .z-index-#{$i} {
    z-index: #{$i};
  }
}


// color
.color-9c { color: #9c9c9c; }
.color-40 { color: #404040; }

// 修改 udesk 客服页面样式
#udesk_container #udesk_panel .udesk_shade{
  width: 20px;
  height: 20px;
  background-color: rgb(255, 79, 76);
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 99999;
  pointer-events: none;
  &:after {
    content: "×";
    color: #fff;
    font-size: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.module-popper {
  white-space: nowrap;
}

</style>
